export const NATIONAL_PARKS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
];
